export default "__VITE_ASSET__1wtkF3BI__"